import Vue from "vue";
import Vuex from "vuex";
import userVUEX from "./modules/userVUEX.js";
import headerVUEX from "./modules/headerVUEX.js";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    notifOpen: false,
  },
  getters: {},
  mutations: {
    setNotifOpen(state, value) {
      Vue.set(state, "notifOpen", value);
    },
  },
  actions: {},
  modules: {
    userVUEX,
    headerVUEX,
  },
});
